import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Http, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { AppSettings } from '../constants/constants';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';
import { CartService } from './cart.service';

@Injectable({
  providedIn: 'root'
})
export class LoginDataService {

  public islogin: boolean = false;

  serviceloginChange: Subject<boolean> = new Subject<boolean>();

  servicecartChange: Subject<boolean> = new Subject<boolean>();

  servicemodelpopupChange: Subject<boolean> = new Subject<boolean>();

  userBO: any = {};
  userrolerightsColl: any = [];
  userView: any = {};

  cartBO: any = {};
  cartdeailsColl: any = [];
  cartView: any = {};


  servicecustomerChange: Subject<boolean> = new Subject<boolean>();

  customerBO: any = {};
  customerOrderMainColl: any = [];
  customerOrderDetailsColl: any = [];
  customerAddressColl: any = [];
  customerWishlistColl: any = [];
  customerLoyaltyColl: any = [];
  customerWalletColl: any = [];
  customerSummaryColl: any = [];
  customerView: any = {};

  constructor(private http: Http, public router: Router, private confirmationDialogService: ConfirmationDialogService, private cartservice: CartService) {

  }


  fnpostInputParams(url, params) {
    const headers = new Headers({
      //'Content-Type':  "application/JSON",
      'sessionid': (localStorage.session === undefined) ? '' : localStorage.session,
      'token': (localStorage.adtoken === undefined) ? '' : JSON.parse(localStorage.adtoken)
    });

    return this.http.post(AppSettings.base_url + url, params, { headers: headers });
  }



  fnGetSessionId() {

    return localStorage.session;
  }




  //Get Customer List
  async fnGetCustomerList() {
    var data = {
      'customerid': 0,
      'companyid': this.cartservice.companyBO.companyid
    }

    await this.fnpostInputParams(AppSettings.getcustomer, data).subscribe(
      (res) => {
        console.log(res.json())
        if (res.json().status == 200) {

          //Main
          this.fnSetCustomerDetailsData(res);


          this.customerView = {
            "customermain": this.customerBO,
            "ordermain": this.customerOrderMainColl,
            "orderdetails": this.customerOrderDetailsColl,
            "customeraddress": this.customerAddressColl,
            "customerwishlist": this.customerWishlistColl,
            "customerloyalty": this.customerLoyaltyColl,
            "customerwallet": this.customerWalletColl,
          }


          this.servicecustomerChange.next(this.customerView);
        }
        else if (res.json().status == 400) {
          this.fnShowErrorMsg('Error' + res.json().err_field);
        }
      },
      (err) => {
        this.fnShowErrorMsg('Error' + err);
      })

  }

  fnSetCustomerDetailsData(res) {
    var _res = res.json().result;

    console.log(_res)

    let _cColl = _res.customerinfo;
    if (_cColl.length > 0) {
      this.customerBO = _cColl[0];
    }
    else {
      this.customerBO = {}
    }

    if (_res.address) {
      this.customerAddressColl = _res.address;
    }

    if (_res.summary) {
      this.customerSummaryColl = _res.summary;
      //Wallet Calculate Summary
      let walletsummaryamt = 0;
      for (let abo of this.customerSummaryColl) {
        walletsummaryamt = abo.walletsummary;
      }

      if (this.customerBO) {
        this.customerBO.walletsummaryamt = walletsummaryamt;
      }

    }

  }




  //Check Sign Up
  fnCheckCustomerSignup(params) {
    return this.fnpostInputParams(AppSettings.checkcustomersignup, params);
  }


  //Check Login
  fnCheckCustomerLogin(params) {
    return this.fnpostInputParams(AppSettings.checkcustomerlogin, params);
  }

  //InsertCustomerSignup
  fnInsertCustomerSignup(params) {
    return this.fnpostInputParams(AppSettings.insertcustomer, params);
  }

  //Get Customer Login
  fnGetCustomerLogin(params) {
    return this.fnpostInputParams(AppSettings.getcustomerlogin, params);
  }

  //Set Cart Customer Login
  async fnSetCartCustomerLogin(params) {
    return await this.fnpostInputParams(AppSettings.setcustomerlogin, params).toPromise();
  }

  //Get Order in Customer
  fnGetOrderInCustomer(params) {
    return this.fnpostInputParams(AppSettings.getorderbycustomer, params);
  }
  fnGetOrder(params) {
    return this.fnpostInputParams(AppSettings.getorderbyorderidcustomer, params);
  }



  fnShowErrorMsg(ex) {
    console.log(ex)
  }

}
